import { gql } from '@apollo/client'

export const GET_CONTENT_BLOCKS = gql`
  query GET_CONTENT_BLOCKS(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [ContentBlockOrderByWithRelationInput!]
  ) {
    findManyContentBlock(
      where: {
        content_block_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      type
      content_block_profiles {
        id
        name
        language
      }
      product_containers {
        id
      }
      createdAt
      updatedAt
    }
    findManyContentBlockCount(
      where: {
        content_block_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`

export const GET_CONTENT_BLOCK = gql`
  query GetContentBlock($id: Int!) {
    findUniqueContentBlock(where: { id: $id }) {
      id
      type
      video_link
      video_type
      main_image {
        id
        src
      }
      content_block_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
      }
    }
  }
`

export const CREATE_CONTENT_BLOCK = gql`
  mutation CREATE_CONTENT_BLOCK(
    $content_block_profiles: [ContentBlockProfileCustomInput!]!
    $content_block_type: ContentBlockType!
    $images: [String]
    $selected_products: [ProductContainerWhereUniqueInput]!
    $video_link: String
    $video_type: ContentBlockVideoType
    $video_autoplay: Boolean!
    $video_loop: Boolean!
    $default_margins: Boolean!
    $object_fit_cover: Boolean!
  ) {
    createNewContentBlock(
      content_block_profiles: $content_block_profiles
      content_block_type: $content_block_type
      images: $images
      selected_products: $selected_products
      video_link: $video_link
      video_type: $video_type
      video_autoplay: $video_autoplay
      video_loop: $video_loop
      default_margins: $default_margins
      object_fit_cover: $object_fit_cover
    ) {
      id
    }
  }
`

export const UPDATE_CONTENT_BLOCK = gql`
  mutation UPDATE_CONTENT_BLOCK(
    $where: ContentBlockWhereUniqueInput!
    $content_block_profiles: [ContentBlockProfileCustomInput!]!
    $content_block_type: ContentBlockType!
    $images: [String]
    $selected_products: [ProductContainerWhereUniqueInput]!
    $video_link: String
    $video_type: ContentBlockVideoType
    $video_autoplay: Boolean!
    $video_loop: Boolean!
    $default_margins: Boolean!
    $object_fit_cover: Boolean!
  ) {
    updateExistingContentBlock(
      where: $where
      content_block_profiles: $content_block_profiles
      content_block_type: $content_block_type
      images: $images
      selected_products: $selected_products
      video_link: $video_link
      video_type: $video_type
      video_autoplay: $video_autoplay
      video_loop: $video_loop
      default_margins: $default_margins
      object_fit_cover: $object_fit_cover
    ) {
      id
      type
      video_link
      video_type
      main_image {
        id
        src
      }
      content_block_profiles {
        id
        name
        description
        language
      }
      product_containers {
        id
      }
    }
  }
`

export const DELETE_MANY_CONTENT_BLOCKS = gql`
  mutation DELETE_CONTENT_BLOCKS($ids: [Int!]!) {
    deleteManyContentBlock(where: { id: { in: $ids } }) {
      count
    }
  }
`
